// src/screens/FormListScreen.css.js - VERSÃO COMPLETA COM TODOS OS ESTILOS

import { StyleSheet } from 'react-native';
import { AVAQualisTheme } from '../theme/theme';

export const styles = StyleSheet.create({
  // Container e Layout Principal
  container: {
    flex: 1,
    backgroundColor: AVAQualisTheme.colors.background,
  },
  
  // CORREÇÃO CRÍTICA: Remover alignItems do style principal do ScrollView
  content: {
    flex: 1,
    paddingHorizontal: AVAQualisTheme.spacing.md,
    paddingTop: AVAQualisTheme.spacing.sm,
  },
  
  // NOVO: Style para contentContainerStyle do ScrollView principal
  scrollContentContainer: {
    flexGrow: 1,
  },
  
  // Header
  appbar: {
    backgroundColor: AVAQualisTheme.colors.primary,
    elevation: 4,
  },
  appbarTitle: {
    color: AVAQualisTheme.colors.onPrimary,
    fontWeight: 'bold',
    fontSize: 18,
  },
  appbarSubtitle: {
    color: AVAQualisTheme.colors.onPrimary,
    opacity: 0.9,
    fontSize: 12,
  },
  
  // Seções
  section: {
    marginBottom: AVAQualisTheme.spacing.lg,
  },
  sectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  sectionTitle: {
    color: AVAQualisTheme.colors.primary,
    fontSize: 20,
    fontWeight: 'bold',
    marginRight: AVAQualisTheme.spacing.sm,
  },
  badge: {
    backgroundColor: AVAQualisTheme.colors.primary,
    color: AVAQualisTheme.colors.onPrimary,
  },
  sectionSubtitle: {
    fontSize: 13,
    color: AVAQualisTheme.colors.secondary,
    marginBottom: AVAQualisTheme.spacing.sm,
    fontStyle: 'italic',
    fontWeight: '500',
  },
  
  // Subseções
  subsectionHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginTop: 12,
    marginBottom: 8,
    backgroundColor: 'rgba(0,0,0,0.03)',
    padding: 6,
    borderRadius: 6,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.primary,
  },
  subsectionTitle: {
    fontSize: 15,
    fontWeight: 'bold',
    color: '#444',
  },
  subsectionBadge: {
    backgroundColor: AVAQualisTheme.colors.info,
    marginLeft: 8,
    fontSize: 11,
  },

  // Cards de Formulário
  card: {
    marginBottom: AVAQualisTheme.spacing.sm,
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    ...AVAQualisTheme.shadows.medium,
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.outline,
  },
  priorityCard: {
    marginBottom: AVAQualisTheme.spacing.sm,
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    ...AVAQualisTheme.shadows.large,
    borderWidth: 2,
    borderColor: AVAQualisTheme.colors.primary,
    borderLeftWidth: 5,
    borderLeftColor: AVAQualisTheme.colors.primary,
  },
  completedCard: {
    marginBottom: AVAQualisTheme.spacing.sm,
    backgroundColor: AVAQualisTheme.colors.surfaceVariant,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    ...AVAQualisTheme.shadows.small,
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.success,
    opacity: 0.8,
  },
  downloadedCard: {
    borderLeftWidth: 4,
    borderLeftColor: AVAQualisTheme.colors.info,
  },
  serverCard: {
    borderLeftWidth: 4,
    borderLeftColor: '#673AB7',
  },
  
  cardContent: {
    padding: 10,
  },
  cardHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    marginBottom: 6,
  },
  titleSection: {
    flex: 1,
    marginRight: 8,
  },
  titleRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  statusSection: {
    alignItems: 'flex-end',
  },
  cardTitle: {
    fontSize: 16,
    color: AVAQualisTheme.colors.onSurface,
    fontWeight: '700',
    lineHeight: 22,
    marginBottom: AVAQualisTheme.spacing.xs,
    flex: 1,
  },
  completedCardTitle: {
    fontSize: 16,
    color: AVAQualisTheme.colors.secondary,
    fontWeight: '600',
    lineHeight: 22,
    marginBottom: AVAQualisTheme.spacing.xs,
    flex: 1,
  },
  metaInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginBottom: 4,
  },
  formMetaInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    marginTop: 3,
    marginBottom: 3,
    padding: 4,
    backgroundColor: 'rgba(0,0,0,0.02)',
    borderRadius: 4,
  },
  versionText: {
    fontSize: 11,
    color: AVAQualisTheme.colors.tertiary,
    fontWeight: '500',
  },
  separator: {
    fontSize: 11,
    color: AVAQualisTheme.colors.tertiary,
    marginHorizontal: AVAQualisTheme.spacing.xs,
  },
  complexityText: {
    fontSize: 11,
    fontWeight: '600',
  },
  description: {
    color: AVAQualisTheme.colors.secondary,
    marginBottom: AVAQualisTheme.spacing.sm,
    lineHeight: 20,
    fontSize: 13,
    fontWeight: '500',
  },
  
  // FormStatusIndicator compacto
  formStatusIndicatorCompact: {
    marginVertical: 6,
    paddingVertical: 6,
    paddingHorizontal: 10,
    borderRadius: 6,
    borderLeftWidth: 3,
  },
  statusCompactRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  statusIconContainer: {
    width: 20,
    height: 20,
    marginRight: 6,
    alignItems: 'center',
    justifyContent: 'center',
  },
  statusIcon: {
    fontSize: 16,
  },
  statusTextContainer: {
    flex: 1,
    marginRight: 8,
  },
  statusLabelCompact: {
    fontSize: 12,
    fontWeight: 'bold',
    marginBottom: 1,
  },
  statusMessageCompact: {
    fontSize: 10,
    fontStyle: 'italic',
  },
  statusDateContainer: {
    alignItems: 'flex-end',
  },
  statusDateCompact: {
    fontSize: 9,
    fontWeight: '500',
  },

  // Indicador de Progresso
  progressIndicatorContainer: {
    marginVertical: 8,
    padding: 8,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: 'rgba(0,0,0,0.1)',
  },
  progressHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 6,
  },
  progressPercentage: {
    fontSize: 12,
    fontWeight: '500',
  },
  progressPercentageBold: {
    fontWeight: 'bold',
    fontSize: 14,
  },
  progressFraction: {
    fontSize: 11,
    fontWeight: '500',
  },
  progressBoldNumber: {
    fontWeight: 'bold',
  },
  progressBarContainer: {
    marginBottom: 6,
  },
  progressBarTrack: {
    height: 6,
    borderRadius: 3,
    backgroundColor: '#E0E0E0',
  },
  progressBarFill: {
    height: 6,
    borderRadius: 3,
  },
  progressStatusText: {
    fontSize: 11,
    fontStyle: 'italic',
    lineHeight: 16,
    color: '#666',
  },
  
  // Metadados inline responsivos
  metadataContainer: {
    marginVertical: AVAQualisTheme.spacing.xs,
    backgroundColor: `${AVAQualisTheme.colors.primary}05`,
    padding: AVAQualisTheme.spacing.xs,
    borderRadius: AVAQualisTheme.borderRadius.sm,
    borderLeftWidth: 2,
    borderLeftColor: AVAQualisTheme.colors.primary,
  },
metadataRow: {
  flexDirection: 'row',
  flexWrap: 'wrap',
  alignItems: 'center',
  marginBottom: 2, // Reduz de 4 para 2
},
  metadataText: {
    fontSize: 11,
    color: AVAQualisTheme.colors.tertiary,
    fontWeight: '600',
    marginRight: AVAQualisTheme.spacing.sm,
    marginBottom: 2,
    flexShrink: 1,
  },

  // NOVO: Estilos para avaliadores editáveis
avaliadorEditContainer: {
  flexDirection: 'row',
  alignItems: 'center',
  backgroundColor: 'rgba(255,255,255,0.7)',
  borderRadius: 4,
  paddingHorizontal: 2, // Reduz padding
  marginHorizontal: 1, // Reduz margem
  paddingVertical: -2, // Negativo para comprimir
},
  avaliadorName: {
    fontSize: 11,
    color: AVAQualisTheme.colors.info,
    fontWeight: 'bold',
  },

  // Unidades inline
  unidadesExpandable: {
    marginTop: AVAQualisTheme.spacing.xs,
  },
  unidadesLabel: {
    fontSize: 12,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.info,
    marginBottom: 4,
  },
  unidadesInlineContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: AVAQualisTheme.spacing.sm,
    marginVertical: 4,
  },
  unidadeCardInline: {
    backgroundColor: `${AVAQualisTheme.colors.info}08`,
    borderRadius: AVAQualisTheme.borderRadius.sm,
    borderLeftWidth: 2,
    borderLeftColor: AVAQualisTheme.colors.info,
    padding: AVAQualisTheme.spacing.xs,
    marginBottom: 4,
    flexBasis: 'calc(50% - 12px)',
    flexShrink: 1,
    flexGrow: 0,
    minWidth: 250,
    maxWidth: '100%',
  },
  unidadeCardInlineHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 2,
  },
  unidadeCardInlineIndex: {
    fontSize: 11,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.info,
    marginRight: 4,
  },
  unidadeCardInlineCode: {
    fontSize: 11,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.info,
  },
  unidadeCardInlineName: {
    fontSize: 11,
    fontWeight: '500',
    color: AVAQualisTheme.colors.onSurface,
    marginBottom: 2,
  },
  unidadeCardInlineContact: {
    fontSize: 10,
    color: AVAQualisTheme.colors.secondary,
    marginBottom: 1,
  },
  unidadeCardInlineHierarchy: {
    fontSize: 9,
    fontStyle: 'italic',
    color: AVAQualisTheme.colors.tertiary,
  },

  syncedDate: {
    fontSize: 11,
    color: AVAQualisTheme.colors.success,
    marginBottom: AVAQualisTheme.spacing.xs,
    fontWeight: '500',
  },
  divider: {
    marginVertical: AVAQualisTheme.spacing.xs,
    backgroundColor: AVAQualisTheme.colors.outline,
  },
  cardFooter: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  questionInfo: {
    flex: 1,
  },
  
  // Layout inline responsivo para informações de requisitos
  questionInfoRow: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: AVAQualisTheme.spacing.xs,
  },
  questionsCount: {
    fontSize: 12,
    color: AVAQualisTheme.colors.secondary,
    fontWeight: '600',
  },
  estimatedTime: {
    fontSize: 11,
    color: AVAQualisTheme.colors.secondary,
    fontWeight: '500',
  },
  
  // Linha de botões com lixeira
  buttonRow: {
    flexDirection: 'row',
    alignItems: 'center',
    flexWrap: 'wrap',
    gap: 6,
  },
  deleteIconButton: {
    marginRight: 4,
  },
  

  // Chips de Status
  availableChip: {
    backgroundColor: `${AVAQualisTheme.colors.info}15`,
    borderColor: AVAQualisTheme.colors.info,
    marginBottom: 3,
  },
  serverChip: {
    backgroundColor: `${AVAQualisTheme.colors.info}15`,
    borderColor: AVAQualisTheme.colors.info,
    marginBottom: 3,
  },
  downloadedChip: {
    backgroundColor: `${AVAQualisTheme.colors.primary}15`,
    borderColor: AVAQualisTheme.colors.primary,
    marginBottom: 3,
  },
  progressChip: {
    backgroundColor: `${AVAQualisTheme.colors.warning}15`,
    borderColor: AVAQualisTheme.colors.warning,
    marginBottom: 3,
  },
  readyChip: {
    backgroundColor: `${AVAQualisTheme.colors.primary}15`,
    borderColor: AVAQualisTheme.colors.primary,
    marginBottom: 3,
  },
  completedChip: {
    backgroundColor: `${AVAQualisTheme.colors.success}20`,
    borderColor: AVAQualisTheme.colors.success,
    marginBottom: 3,
  },
  chipText: {
    fontSize: 10,
    fontWeight: '600',
  },
  
  // Botões de Ação
  downloadButton: {
    minWidth: 90,
    borderRadius: AVAQualisTheme.borderRadius.md,
    backgroundColor: AVAQualisTheme.colors.info,
  },
  startButton: {
    minWidth: 90,
    borderRadius: AVAQualisTheme.borderRadius.md,
    backgroundColor: AVAQualisTheme.colors.success,
  },
  continueButton: {
    minWidth: 90,
    borderRadius: AVAQualisTheme.borderRadius.md,
    backgroundColor: AVAQualisTheme.colors.warning,
  },
  syncButton: {
    minWidth: 90,
    borderRadius: AVAQualisTheme.borderRadius.md,
    backgroundColor: AVAQualisTheme.colors.primary,
  },
  viewButton: {
    minWidth: 90,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.success,
    backgroundColor: '#f5f5f5',
  },
  viewButtonLabel: {
    fontSize: 12,
    fontWeight: '600',
    color: AVAQualisTheme.colors.success,
  },
  buttonContent: {
    height: 36,
    paddingHorizontal: AVAQualisTheme.spacing.sm,
  },
  buttonLabel: {
    fontSize: 12,
    fontWeight: '600',
  },
  
  // Card de Estado Offline
  offlineCard: {
    backgroundColor: '#FFEBEE',
    marginBottom: 12,
    borderLeftWidth: 4,
    borderLeftColor: '#F44336',
  },
  offlineCardContent: {
    flexDirection: 'row',
    alignItems: 'center',
    padding: 10,
    flexWrap: 'wrap',
  },
  offlineTextContainer: {
    flex: 1,
    marginLeft: 10,
    marginRight: 8,
  },
  offlineCardTitle: {
    fontSize: 13,
    fontWeight: 'bold',
    color: '#D32F2F',
  },
  offlineCardMessage: {
    fontSize: 11,
    color: '#616161',
  },
  retryButton: {
    backgroundColor: '#F44336',
    marginLeft: 8,
  },

  // Card de informações
  infoCard: {
    margin: 16,
    marginBottom: 8,
    backgroundColor: '#E3F2FD',
    borderLeftWidth: 4,
    borderLeftColor: '#1976D2',
  },
  infoCardContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  infoCardText: {
    flex: 1,
    marginLeft: 12,
    fontSize: 14,
    color: '#1565C0',
    lineHeight: 20,
  },
  
  // Estado Vazio
  emptyCard: {
    backgroundColor: AVAQualisTheme.colors.surfaceVariant,
    borderStyle: 'dashed',
    borderWidth: 2,
    borderColor: AVAQualisTheme.colors.outline,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    marginTop: AVAQualisTheme.spacing.lg,
  },
  emptyContent: {
    alignItems: 'center',
    paddingVertical: AVAQualisTheme.spacing.lg,
  },
  emptyIconContainer: {
    position: 'relative',
    marginBottom: AVAQualisTheme.spacing.md,
    alignItems: 'center',
    justifyContent: 'center',
  },
  emptyTitle: {
    textAlign: 'center',
    marginBottom: AVAQualisTheme.spacing.sm,
    color: AVAQualisTheme.colors.primary,
    fontSize: 17,
  },
  emptyText: {
    textAlign: 'center',
    color: AVAQualisTheme.colors.secondary,
    lineHeight: 20,
    fontSize: 13,
    maxWidth: '85%',
    fontWeight: '500',
  },
  
  // Loading Overlay
  loadingOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0,0,0,0.75)',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    zIndex: 1000,
  },
  loadingContent: {
    backgroundColor: AVAQualisTheme.colors.surface,
    padding: AVAQualisTheme.spacing.lg,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    alignItems: 'center',
    ...AVAQualisTheme.shadows.large,
    minWidth: 180,
    maxWidth: '80%',
  },
  loadingText: {
    color: AVAQualisTheme.colors.primary,
    marginTop: AVAQualisTheme.spacing.md,
    fontSize: 15,
    fontWeight: 'bold',
    textAlign: 'center',
  },
  loadingSubtext: {
    color: AVAQualisTheme.colors.secondary,
    marginTop: AVAQualisTheme.spacing.xs,
    fontSize: 12,
    fontWeight: '500',
    textAlign: 'center',
  },
  
  // Estilos para o Custom Dialog
  modalOverlay: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  dialogContainer: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    minWidth: 280,
    maxWidth: '90%',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.25,
    shadowRadius: 12,
    elevation: 8,
  },
  dialogHeader: {
    paddingHorizontal: 20,
    paddingTop: 20,
    paddingBottom: 12,
  },
  dialogTitle: {
    fontSize: 17,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
  },
  dialogContent: {
    paddingHorizontal: 20,
    paddingBottom: 16,
  },
  dialogMessage: {
    fontSize: 15,
    lineHeight: 22,
    color: AVAQualisTheme.colors.onSurface,
  },
  dialogActions: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    paddingHorizontal: 16,
    paddingBottom: 16,
    gap: 8,
  },
  dialogButton: {
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderRadius: AVAQualisTheme.borderRadius.md,
    minWidth: 70,
    alignItems: 'center',
    justifyContent: 'center',
  },
  dialogButtonSecondary: {
    backgroundColor: 'transparent',
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.outline,
  },
  dialogButtonPrimary: {
    backgroundColor: AVAQualisTheme.colors.primary,
  },
  dialogButtonText: {
    fontSize: 13,
    fontWeight: '600',
  },
  dialogButtonTextSecondary: {
    color: AVAQualisTheme.colors.primary,
  },
  dialogButtonTextPrimary: {
    color: AVAQualisTheme.colors.onPrimary,
  },

  // NOVO: Estilos para o seletor de avaliador
  avaliadorSelectorContainer: {
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    maxHeight: '80%',
    width: '90%',
    maxWidth: 400,
    elevation: 5,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
  },
  avaliadorSelectorHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#E0E0E0',
  },
  avaliadorSelectorTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
  },
  searchContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#F5F5F5',
    borderRadius: 8,
    paddingHorizontal: 12,
    paddingVertical: 8,
    margin: 16,
  },
  searchInput: {
    flex: 1,
    marginLeft: 8,
    fontSize: 14,
    color: '#333',
    backgroundColor: 'transparent',
    borderWidth: 0,
  },
  
  // CORREÇÃO CRÍTICA: Remover alignItems do style principal
  avaliadorList: {
    maxHeight: 400,
    paddingBottom: 16,
  },
  
  // NOVO: Style para contentContainerStyle do ScrollView do avaliador
  avaliadorListContent: {
    flexGrow: 1,
  },
  
  avaliadorItem: {
    paddingHorizontal: 16,
    paddingVertical: 12,
    borderBottomWidth: 1,
    borderBottomColor: '#F0F0F0',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  avaliadorItemSelected: {
    backgroundColor: `${AVAQualisTheme.colors.primary}15`,
    borderBottomColor: AVAQualisTheme.colors.primary,
  },
  avaliadorItemContent: {
    flex: 1,
  },
  avaliadorItemName: {
    fontSize: 16,
    fontWeight: '600',
    color: AVAQualisTheme.colors.onSurface,
    marginBottom: 2,
  },
  avaliadorItemEmail: {
    fontSize: 13,
    color: AVAQualisTheme.colors.secondary,
  },

  // Estilos para o LoginInviteCard
  loginInviteCard: {
    marginHorizontal: 16,
    marginTop: 24,
    marginBottom: 16,
    backgroundColor: '#FFFFFF',
    borderRadius: 16,
    elevation: 4,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    borderWidth: 2,
    borderColor: AVAQualisTheme.colors.primary,
  },
  loginInviteContent: {
    alignItems: 'center',
    padding: 24,
  },
  iconContainer: {
    position: 'relative',
    marginBottom: 24,
  },
  iconBadge: {
    position: 'absolute',
    bottom: -5,
    right: -5,
    backgroundColor: AVAQualisTheme.colors.success,
    borderRadius: 20,
    width: 40,
    height: 40,
    alignItems: 'center',
    justifyContent: 'center',
    borderWidth: 3,
    borderColor: '#FFFFFF',
  },
  loginInviteTitle: {
    fontSize: 28,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
    textAlign: 'center',
    marginBottom: 8,
  },
  loginInviteSubtitle: {
    fontSize: 20,
    color: AVAQualisTheme.colors.secondary,
    textAlign: 'center',
    marginBottom: 16,
    fontWeight: '600',
  },
  loginInviteMessage: {
    fontSize: 16,
    color: AVAQualisTheme.colors.onSurface,
    textAlign: 'center',
    lineHeight: 24,
    marginBottom: 24,
    paddingHorizontal: 16,
  },
  benefitsList: {
    width: '100%',
    marginBottom: 32,
  },
  benefitItem: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 16,
    paddingHorizontal: 8,
  },
 benefitText: {
    flex: 1,
    marginLeft: 12,
    fontSize: 15,
    color: AVAQualisTheme.colors.onSurface,
    lineHeight: 22,
  },
  loginButton: {
    backgroundColor: AVAQualisTheme.colors.primary,
    borderRadius: 25,
    paddingHorizontal: 32,
    elevation: 3,
    shadowColor: AVAQualisTheme.colors.primary, 
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.3,
    shadowRadius: 4,
  },
  loginButtonContent: {
    height: 50,
    paddingHorizontal: 16,
  },
  loginButtonLabel: {
    fontSize: 18,
    fontWeight: 'bold',
    color: '#FFFFFF',
  },
  footerText: {
    marginTop: 24,
    fontSize: 12,
    color: AVAQualisTheme.colors.tertiary,
    textAlign: 'center',
    fontStyle: 'italic',
  },
  
  // Icon buttons
  downloadIconButton: {
    margin: 0,
    padding: 4,
    backgroundColor: 'rgba(0, 150, 136, 0.1)',
  },
  
  // Espaçadores
  bottomSpacer: {
    height: AVAQualisTheme.spacing.lg,
  },
// Estilos para edição de campos
  titleEditContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  descriptionEditContainer: {
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  editIconButton: {
  marginLeft: 4,
  padding: 0,
  margin: -4, // Reduz espaçamento geral
},
 editIconButtonSmall: {
  marginLeft: 4,
  padding: 0,
  margin: -6, // Mais agressivo para compensar
},
 metadataEditGroup: {
  flexDirection: 'row',
  alignItems: 'center',
  marginRight: 16,
  marginBottom: 0, // Remove espaçamento inferior
},
  metadataValueText: {
    fontSize: 11,
    color: AVAQualisTheme.colors.info,
    fontWeight: 'bold',
  },
 metadataEditIcon: {
  padding: 0,
  marginLeft: 2,
  margin: -4, // Reduz espaçamento vertical
  marginTop: -6, // Extra para alinhar melhor
},
  // Modal de edição genérico
  editModalContainer: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    margin: 20,
    ...AVAQualisTheme.shadows.large,
  },
  editModalHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: AVAQualisTheme.spacing.md,
    paddingVertical: AVAQualisTheme.spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: AVAQualisTheme.colors.outline,
  },
  editModalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
  },
  editModalContent: {
    padding: AVAQualisTheme.spacing.md,
  },
  editModalInput: {
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.outline,
    borderRadius: AVAQualisTheme.borderRadius.sm,
    padding: AVAQualisTheme.spacing.sm,
    fontSize: 14,
    color: AVAQualisTheme.colors.onSurface,
    backgroundColor: AVAQualisTheme.colors.surfaceVariant,
  },
  editModalInputMultiline: {
    minHeight: 100,
    textAlignVertical: 'top',
  },
  editModalError: {
    color: AVAQualisTheme.colors.error,
    fontSize: 12,
    marginTop: AVAQualisTheme.spacing.xs,
    fontWeight: '500',
  },
  editModalFooter: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: AVAQualisTheme.spacing.md,
    borderTopWidth: 1,
    borderTopColor: AVAQualisTheme.colors.outline,
    gap: AVAQualisTheme.spacing.sm,
  },
  
  // Unidades header
  unidadesHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },

  // Processos header
  processosHeaderRow: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    flex: 1,
  },

  // Modal de edição de unidades
  unidadeEditModalContainer: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    margin: 20,
    maxHeight: '80%',
    ...AVAQualisTheme.shadows.large,
  },
  unidadeEditModalHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: AVAQualisTheme.spacing.md,
    paddingVertical: AVAQualisTheme.spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: AVAQualisTheme.colors.outline,
  },
  unidadeEditModalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
  },
  unidadeEditModalContent: {
    padding: AVAQualisTheme.spacing.md,
    maxHeight: 400,
  },
  unidadeEditSearchContainer: {
    marginBottom: AVAQualisTheme.spacing.md,
    position: 'relative',
    zIndex: 1000,
  },
  unidadeEditSearchInput: {
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.outline,
    borderRadius: AVAQualisTheme.borderRadius.sm,
    padding: AVAQualisTheme.spacing.sm,
    fontSize: 14,
    backgroundColor: AVAQualisTheme.colors.surfaceVariant,
  },
  unidadeEditDropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.primary,
    marginTop: 4,
    elevation: 5,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    zIndex: 1001,
  },
  unidadeEditDropdownItem: {
    padding: AVAQualisTheme.spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: AVAQualisTheme.colors.outline,
  },
  unidadeEditDropdownText: {
    fontSize: 14,
    color: AVAQualisTheme.colors.onSurface,
    fontWeight: '600',
  },
  unidadeEditDropdownSubtext: {
    fontSize: 12,
    color: AVAQualisTheme.colors.secondary,
    marginTop: 2,
  },
  unidadeEditSelectedTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.secondary,
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  unidadeEditSelectedCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: AVAQualisTheme.colors.surfaceVariant,
    borderRadius: AVAQualisTheme.borderRadius.sm,
    padding: AVAQualisTheme.spacing.sm,
    marginBottom: AVAQualisTheme.spacing.xs,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.info,
  },
  unidadeEditSelectedInfo: {
    flex: 1,
  },
  unidadeEditSelectedCode: {
    fontSize: 13,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.info,
  },
  unidadeEditSelectedName: {
    fontSize: 13,
    color: AVAQualisTheme.colors.onSurface,
    marginTop: 2,
  },
  unidadeEditSelectedContact: {
    fontSize: 11,
    color: AVAQualisTheme.colors.secondary,
    marginTop: 2,
  },
  unidadeEditModalFooter: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: AVAQualisTheme.spacing.md,
    borderTopWidth: 1,
    borderTopColor: AVAQualisTheme.colors.outline,
    gap: AVAQualisTheme.spacing.sm,
  },
  
  // Modal de edição de processos
  processoEditModalContainer: {
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.lg,
    margin: 20,
    maxHeight: '80%',
    ...AVAQualisTheme.shadows.large,
  },
  processoEditModalHeader: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    paddingHorizontal: AVAQualisTheme.spacing.md,
    paddingVertical: AVAQualisTheme.spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: AVAQualisTheme.colors.outline,
  },
  processoEditModalTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.primary,
  },
  processoEditModalContent: {
    padding: AVAQualisTheme.spacing.md,
    maxHeight: 400,
  },
  processoEditSearchContainer: {
    marginBottom: AVAQualisTheme.spacing.md,
    position: 'relative',
    zIndex: 1000,
  },
  processoEditSearchInput: {
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.outline,
    borderRadius: AVAQualisTheme.borderRadius.sm,
    padding: AVAQualisTheme.spacing.sm,
    fontSize: 14,
    backgroundColor: AVAQualisTheme.colors.surfaceVariant,
  },
  processoEditDropdown: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    backgroundColor: AVAQualisTheme.colors.surface,
    borderRadius: AVAQualisTheme.borderRadius.md,
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.primary,
    marginTop: 4,
    elevation: 5,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.25,
    shadowRadius: 3.84,
    zIndex: 1001,
  },
  processoEditDropdownItem: {
    padding: AVAQualisTheme.spacing.sm,
    borderBottomWidth: 1,
    borderBottomColor: AVAQualisTheme.colors.outline,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  processoEditDropdownText: {
    fontSize: 14,
    color: AVAQualisTheme.colors.onSurface,
    fontWeight: '600',
  },
  processoEditDropdownId: {
    fontSize: 12,
    color: AVAQualisTheme.colors.secondary,
    fontStyle: 'italic',
  },
  processoEditNoResults: {
    padding: AVAQualisTheme.spacing.md,
    alignItems: 'center',
  },
  processoEditNoResultsText: {
    fontSize: 13,
    color: AVAQualisTheme.colors.secondary,
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  processoEditSelectedTitle: {
    fontSize: 14,
    fontWeight: 'bold',
    color: AVAQualisTheme.colors.secondary,
    marginBottom: AVAQualisTheme.spacing.sm,
  },
  processoEditSelectedCard: {
    backgroundColor: AVAQualisTheme.colors.surfaceVariant,
    borderRadius: AVAQualisTheme.borderRadius.sm,
    padding: AVAQualisTheme.spacing.sm,
    marginBottom: AVAQualisTheme.spacing.xs,
    borderLeftWidth: 3,
    borderLeftColor: AVAQualisTheme.colors.info,
  },
  processoEditSelectedInfo: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  processoEditSelectedName: {
    fontSize: 14,
    fontWeight: '600',
    color: AVAQualisTheme.colors.onSurface,
  },
  processoEditSelectedId: {
    fontSize: 11,
    color: AVAQualisTheme.colors.secondary,
    fontStyle: 'italic',
    marginTop: 2,
  },
  processoEditSelectedActions: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  processoEditingContainer: {
    padding: AVAQualisTheme.spacing.xs,
  },
  processoEditingInput: {
    borderWidth: 1,
    borderColor: AVAQualisTheme.colors.primary,
    borderRadius: AVAQualisTheme.borderRadius.sm,
    padding: AVAQualisTheme.spacing.xs,
    fontSize: 14,
    backgroundColor: AVAQualisTheme.colors.surface,
    marginBottom: AVAQualisTheme.spacing.xs,
  },
  processoEditingActions: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    gap: AVAQualisTheme.spacing.xs,
  },
  processoEditWarning: {
    fontSize: 11,
    color: AVAQualisTheme.colors.error,
    fontStyle: 'italic',
    marginTop: AVAQualisTheme.spacing.xs,
    textAlign: 'center',
  },
  processoEditModalFooter: {
    flexDirection: 'row',
    justifyContent: 'flex-end',
    padding: AVAQualisTheme.spacing.md,
    borderTopWidth: 1,
    borderTopColor: AVAQualisTheme.colors.outline,
    gap: AVAQualisTheme.spacing.sm,
  },

  // Novos estilos para sincronização
  syncIconButton: {
    marginLeft: 8,
    backgroundColor: 'rgba(255, 111, 0, 0.1)',
  },
  
  syncStatusBadge: {
    position: 'absolute',
    top: 8,
    right: 8,
    paddingHorizontal: 8,
    paddingVertical: 4,
    borderRadius: 12,
    flexDirection: 'row',
    alignItems: 'center',
  },
  
  syncStatusBadgeSynced: {
    backgroundColor: '#E8F5E9',
  },
  
  syncStatusBadgeLocalNewer: {
    backgroundColor: '#FFF8E1',
  },
  
  syncStatusBadgeCloudNewer: {
    backgroundColor: '#FFEBEE',
  },
  
  syncStatusBadgeText: {
    fontSize: 10,
    fontWeight: '600',
    marginLeft: 4,
  },
  
  syncStatusBadgeTextSynced: {
    color: '#2E7D32',
  },
  
  syncStatusBadgeTextLocalNewer: {
    color: '#FF6F00',
  },
  
  syncStatusBadgeTextCloudNewer: {
    color: '#D32F2F',
  },
  // Estilos para o editor de emails
emailEditorContainer: {
  backgroundColor: AVAQualisTheme.colors.surface,
  borderRadius: AVAQualisTheme.borderRadius.lg,
  margin: 20,
  maxHeight: '80%',
  ...AVAQualisTheme.shadows.large,
},
emailEditorHeader: {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingHorizontal: AVAQualisTheme.spacing.md,
  paddingVertical: AVAQualisTheme.spacing.sm,
  borderBottomWidth: 1,
  borderBottomColor: AVAQualisTheme.colors.outline,
},
emailEditorTitle: {
  fontSize: 18,
  fontWeight: 'bold',
  color: AVAQualisTheme.colors.primary,
},
emailEditorContent: {
  padding: AVAQualisTheme.spacing.md,
  maxHeight: 400,
},
emailInputContainer: {
  flexDirection: 'row',
  marginBottom: AVAQualisTheme.spacing.md,
  gap: AVAQualisTheme.spacing.sm,
},
emailTextInput: {
  flex: 1,
  borderWidth: 1,
  borderColor: AVAQualisTheme.colors.outline,
  borderRadius: AVAQualisTheme.borderRadius.sm,
  padding: AVAQualisTheme.spacing.sm,
  fontSize: 14,
  color: AVAQualisTheme.colors.onSurface,
  backgroundColor: AVAQualisTheme.colors.surfaceVariant,
},
addEmailButton: {
  justifyContent: 'center',
  borderRadius: AVAQualisTheme.borderRadius.md,
  backgroundColor: AVAQualisTheme.colors.primary,
},
emailErrorText: {
  color: AVAQualisTheme.colors.error,
  fontSize: 12,
  marginBottom: AVAQualisTheme.spacing.sm,
  fontWeight: '500',
},
emailListTitle: {
  fontSize: 14,
  fontWeight: 'bold',
  color: AVAQualisTheme.colors.secondary,
  marginTop: AVAQualisTheme.spacing.md,
  marginBottom: AVAQualisTheme.spacing.sm,
},
noEmailsText: {
  fontSize: 14,
  color: AVAQualisTheme.colors.tertiary,
  fontStyle: 'italic',
  textAlign: 'center',
  marginVertical: AVAQualisTheme.spacing.lg,
},
emailItemRow: {
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'space-between',
  paddingVertical: AVAQualisTheme.spacing.sm,
  paddingHorizontal: AVAQualisTheme.spacing.sm,
  backgroundColor: AVAQualisTheme.colors.surfaceVariant,
  borderRadius: AVAQualisTheme.borderRadius.sm,
  marginBottom: AVAQualisTheme.spacing.xs,
  borderLeftWidth: 3,
  borderLeftColor: AVAQualisTheme.colors.info,
},
emailItemText: {
  fontSize: 14,
  color: AVAQualisTheme.colors.onSurface,
  flex: 1,
  fontWeight: '500',
},
emailEditorFooter: {
  flexDirection: 'row',
  justifyContent: 'flex-end',
  padding: AVAQualisTheme.spacing.md,
  borderTopWidth: 1,
  borderTopColor: AVAQualisTheme.colors.outline,
  gap: AVAQualisTheme.spacing.sm,
},


// Ajustes para ícones de edição encavalados
permanentDeleteButton: {
  marginLeft: 8,
  backgroundColor: 'rgba(211, 47, 47, 0.1)',
  borderRadius: 20,
  padding: 0, // Adiciona padding zero
  margin: -4, // Reduz espaçamento
},
processosEditIcon: {
  padding: 0,
  marginLeft: 8,
  margin: -4, // Adiciona margem negativa
},
unidadesEditIcon: {
  padding: 0,
  marginRight: 8,
  margin: -4, // Adiciona margem negativa
},

});